<ng-container thr-parent-form>
    <input name="isSigned" type="checkbox" class="d-none" [ngModel]="isSigned" required />

    <h4 class="mat-subheading-1 text-blue font-weight-bold mb-4">
        {{ 'operative.contract-participants' | translate }}

        <ng-container *ngIf="signedBy === 'one'"> ({{ 'operative.sole-signature' | translate }}) </ng-container>
        <ng-container *ngIf="signedBy !== 'one'"> ({{ 'operative.joint-signature' | translate }}) </ng-container>
    </h4>

    <table class="table participants mb-5">
        <thead>
            <tr>
                <th></th>
                <th class="d-none d-md-table-cell">
                    {{ 'form.participants' | translate }}
                </th>
                <th>{{ 'form.name-and-surname' | translate }}</th>
                <th class="d-none d-md-table-cell">
                    {{ 'form.email' | translate }}
                </th>
                <th class="d-none d-md-table-cell">
                    {{ 'form.phone' | translate }}
                </th>
                <th
                    [class.d-none]="!allowDigital"
                    matTooltipPosition="above"
                    matTooltipClass="blue-tooltip"
                    [matTooltip]="'operative.sign-digital-face-to-face-help' | translate"
                >
                    {{ 'operative.sign-digital-face-to-face' | translate }}
                </th>
                <th
                    [class.d-none]="!allowDigital"
                    matTooltipPosition="above"
                    matTooltipClass="blue-tooltip"
                    [matTooltip]="'operative.sign-digital-remote-help' | translate"
                >
                    {{ 'operative.sign-digital-remote' | translate }}
                </th>
                <th
                    [class.d-none]="!allowHandwritten"
                    matTooltipPosition="above"
                    matTooltipClass="blue-tooltip"
                    [matTooltip]="'operative.sign-handwriting-help' | translate"
                >
                    {{ 'operative.sign-handwriting' | translate }}
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-template ngFor let-participant [ngForOf]="participants" let-i="index">
                <tr>
                    <td>
                        <i class="icon-natural-plus"></i>
                    </td>
                    <td class="d-none d-md-table-cell" [ngSwitch]="participant.participantRelation">
                        <strong class="text-uppercase text-blue" *ngSwitchCase="OrderClientRelation.TITULAR">
                            <ng-container *ngIf="participant.isSoleHolder">{{ 'form.holder' | translate }}</ng-container>
                            <ng-container *ngIf="!participant.isSoleHolder">{{ 'form.co-holder' | translate }}</ng-container>
                        </strong>
                        <strong class="text-uppercase text-blue" *ngSwitchCase="OrderClientRelation.AUTHORISED">
                            {{ 'form.authorized' | translate }}
                        </strong>
                        <strong class="text-uppercase text-blue" *ngSwitchCase="OrderClientRelation.TUTOR">
                            {{ 'form.tutor' | translate }}
                        </strong>
                        <strong class="text-uppercase text-blue" *ngSwitchDefault>
                            {{ 'form.attorney-in-fact' | translate }}
                        </strong>
                    </td>
                    <td>
                        <strong>{{ participant.name }}</strong
                        >&nbsp;<strong>{{ participant.surname }}</strong>
                    </td>
                    <td class="d-none d-md-table-cell">
                        <strong>{{ participant.email }}</strong>
                    </td>
                    <td class="d-none d-md-table-cell">
                        <strong>{{ participant.phone }}</strong>
                    </td>
                    <td class="text-center" [class.d-none]="!allowDigital" style="width: 80px">
                        <mat-radio-button
                            [name]="'radioSignature' + i"
                            color="blue-gray"
                            [value]="ClientSignatureType.IN_PERSON_ELECTRONIC"
                            [checked]="participant.signatureType === ClientSignatureType.IN_PERSON_ELECTRONIC"
                            [disabled]="!participant.email || !participant.phone || !allowDigital"
                            (change)="onParticipantSign(participant, $event.value)"
                        ></mat-radio-button>
                    </td>
                    <td class="text-center" [class.d-none]="!allowDigital" style="width: 80px">
                        <mat-radio-button
                            [name]="'radioSignature' + i"
                            color="blue-gray"
                            [value]="ClientSignatureType.REMOTE_ELECTRONIC"
                            [checked]="participant.signatureType === ClientSignatureType.REMOTE_ELECTRONIC"
                            [disabled]="!participant.email || !participant.phone || !allowDigital"
                            (change)="onParticipantSign(participant, $event.value)"
                        ></mat-radio-button>
                    </td>
                    <td class="text-center" [class.d-none]="!allowHandwritten" style="width: 65px">
                        <mat-radio-button
                            [name]="'radioSignature' + i"
                            color="blue-gray"
                            [value]="ClientSignatureType.HANDWRITTEN"
                            [checked]="participant.signatureType === ClientSignatureType.HANDWRITTEN"
                            [disabled]="!allowHandwritten"
                            (change)="onParticipantSign(participant, $event.value)"
                        ></mat-radio-button>
                    </td>
                </tr>
            </ng-template>
        </tbody>
    </table>
</ng-container>
